import urljoin from 'url-join';
import { EmbedConfig } from '../..';
import render from '../../designs/paper';

import GothamLightWoff2 from '../../../../../../client/assets/Gotham-Light.woff2';
import DomaineTextWoff2 from '../../../../../../client/assets/DomaineText-Regular.woff2';

import './styles/style.scss';

const additionalFonts = (config: EmbedConfig) => {
  const GothamLightWoff2Path = urljoin(config.goBaseUrl, GothamLightWoff2);
  const DomaineTextWoff2Path = urljoin(config.goBaseUrl, DomaineTextWoff2);

  return `
    @font-face {
      font-family: 'Gotham Light';
      font-style: normal;
      src: url('${GothamLightWoff2Path}') format('woff2');
    }
      
      @font-face {
      font-family: 'Domaine Text';
      font-style: normal;
      src: url('${DomaineTextWoff2Path}') format('woff2');
    }`;
};

render(additionalFonts);
